<app-access-item [icon]="'/assets/icons/eye-open.svg'" [iconColor]="iconColor()" [hideOverflow]="true">
  <app-access-item-header>
    <span>View Only</span>
  </app-access-item-header>
  <app-access-item-cta>
    <label for="view-only" class="save-toggle">
      <app-switch [smallish]="true" [noInteraction]="!galleryPermissions().can_edit">
        <input
          type="checkbox"
          id="view-only"
          [(ngModel)]="viewOnly"
          (ngModelChange)="toggle($event)"
          [disabled]="!galleryPermissions().can_edit"
        />
        <label for="view-only"></label>
      </app-switch>
    </label>
  </app-access-item-cta>
</app-access-item>
